import { gql } from "@apollo/client";

export const MUTATION_EXECUTE_QUICK_WIN = gql`
  mutation ExecuteQuickWin($input: LlmQuickWinInput!) {
    executeLlmQuickWin(input: $input) {
      ... on LlmQuickWinResult {
        result
        id
      }
      ... on InvalidLlmStrategyError {
        errorCode
        message
      }

      ... on MissingLlmStrategyError {
        errorCode
        message
      }

      ... on InvalidLlmCredentialsError {
        errorCode
        message
      }

      ... on AiTermsNotAcceptedError {
        errorCode
        message
      }
      ... on LlmDisabledError {
        errorCode
        message
      }
    }
  }
`;

export const QUERY_QUICK_WIN_HANDLERS = gql`
  query quickWinHandlers {
    quickWinHandlers {
      code
      name
      description
      args {
        defaultValue
        name
        description
      }
    }
  }
`;

export const QUERY_QUICK_WIN_STRATEGIES = gql`
  query quickWinStrategies {
    quickWinStrategies {
      enabled
      code
      config {
        code
        args {
          value
          name
        }
      }
      handler {
        code
        name
        description
        args {
          defaultValue
          name
          description
        }
      }
    }
  }
`;

export const QUERY_QUICK_WIN_RESULT_BY_ID = gql`
  query quickWinResultById($id: ID!) {
    quickWinResultById(id: $id) {
      id
      result
    }
  }
`;

export const MUTATION_EMAIL_QUICK_WIN_RESULT = gql`
  mutation EmailQuickWinResult($id: ID!, $email: String!) {
    emailLlmQuickWinResult(id: $id, email: $email)
  }
`;
